import React from "react";
import ReportsMenu from "./reports/reports-menu.jsx";

export default class PayrollAdminReports extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div style={{backgroundColor: "#efefef"}}>
                <ReportsMenu role={this.props.route.role} />
            </div>
        );
    }
}